const initBlock = async function( block ) {
	let show = true;
	const counter = block.find( ".js-counter" );
	const countbox = block.find( ".section-counter__counter" );

	if ( counter.length < 1 ) {
		return;
	}

	$( window ).on( "scroll load resize", function() {
		if ( !show ) {
			return false;
		}

		counter.parent().css( "opacity", "0" );
		let windowScrollTop = $( window ).scrollTop();
		let counterOffsetTop = $( countbox ).offset().top;
		let windowHeight = $( window ).height();
		let documentHeight = $( document ).height();
		let counterHeight = $( countbox ).outerHeight();
		if ( windowScrollTop + ( windowHeight / 2 ) >= counterOffsetTop || windowHeight + windowScrollTop === documentHeight || counterHeight + counterOffsetTop < windowHeight ) {
			counter.each( function() {
				const counter = $( this );
				counter.text( "0" );
				counter.parent().css( "opacity", "1" );
				const speed = 200;
				const updateCount = () => {
					const count = parseInt( counter.text() );
					const target = parseInt( $( this ).data( "max" ) );
					const increment = Math.trunc( target / speed );
					if ( count < target ) {
						counter.text( count + increment );
						setTimeout( updateCount, 1 );
					} else {
						counter.text( target );
					}
				};
				updateCount();
			} );

			show = false;
		}
	} );
};

themeUtils.loadBlock( initBlock, "counter", ".section-counter" );
